






import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ListItemLabel extends Vue {
    @Prop({ type: Boolean, default: true }) readonly grow!: boolean
}
